(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root && root.document) api.mount(root.document, root.location);
}(typeof window !== 'undefined' ? window : null, function () {
  'use strict';

  function values(url, key) {
    return url.searchParams.getAll(key).reduce(function (all, value) {
      return all.concat(value.split(','));
    }, []).filter(function (value) { return value !== ''; });
  }

  function change(current, key, value) {
    var url = new URL(current);
    url.searchParams.delete(key);
    if (value) url.searchParams.set(key, value);
    url.searchParams.delete('page');
    return url;
  }

  function removeValue(current, key, value) {
    var url = new URL(current);
    var kept = values(url, key).filter(function (candidate) { return candidate !== value; });
    url.searchParams.delete(key);
    kept.forEach(function (candidate) { url.searchParams.append(key, candidate); });
    url.searchParams.delete('page');
    return url;
  }

  function changePath(current, path) {
    var url = new URL(current);
    var target = new URL(path.replace(/&amp;/g, '&'), url.origin);
    if (target.origin !== url.origin) throw new Error('Unexpected filter destination');
    url.pathname = target.pathname;
    if (url.pathname === '/collections/vendors' && url.searchParams.has('q')) {
      url.searchParams.delete('constraint');
      target.searchParams.getAll('constraint').forEach(function (value) {
        url.searchParams.append('constraint', value);
      });
    }
    url.searchParams.delete('page');
    return url;
  }

  function clear(current, base) {
    var old = new URL(current);
    var url = new URL(base, old.origin);
    ['sort_by', 'q'].forEach(function (key) {
      if (old.searchParams.has(key)) url.searchParams.set(key, old.searchParams.get(key));
    });
    return url;
  }

  // Alternate templates keep the original collection membership and tag path.
  // Complex sale/search views keep their own renderer and constraints.
  var typeViews = {
    'Trukit': 'trukitE', 'Dekit': 'dekitB', 'Renkaat': 'renkaatF',
    'Kengät': 'kengatC', 'T-Paidat': 't-paidatB',
    'Hupparit': 't-paidat', 'Colleget': 't-paidat', 'Paidat': 't-paidat'
  };
  var dimensionKeys = ['fk_size', 'deck_group', 'group', 'mm_group'];

  function typeView(url) {
    var types = Array.from(new Set(values(url, 'filter.p.product_type')));
    if (types.length) {
      return types.length === 1 && Object.prototype.hasOwnProperty.call(typeViews, types[0]) ? typeViews[types[0]] : '';
    }
    // A legacy tag URL is still a collection scope, not a native type filter.
    // Choose its controls without changing its product membership or tags.
    var path = url.pathname.match(/\/collections\/[^/]+\/([^/]+)\/?$/);
    if (!path) return '';
    var tagViews = { trukit: 'trukitE', dekit: 'dekitB', renkaat: 'renkaatF',
      kengat: 'kengatC', 't-paidat': 't-paidatB', hupparit: 't-paidat',
      colleget: 't-paidat', paidat: 't-paidat' };
    var tags;
    try { tags = decodeURIComponent(path[1]).toLowerCase().split('+'); }
    catch (error) { return ''; }
    var views = Array.from(new Set(tags.map(function (tag) {
      return Object.prototype.hasOwnProperty.call(tagViews, tag) ? tagViews[tag] : '';
    }).filter(Boolean)));
    return views.length === 1 ? views[0] : '';
  }

  function normalizeNativeValues(url) {
    ['filter.p.vendor', 'filter.p.product_type'].forEach(function (key) {
      var raw = url.searchParams.getAll(key);
      var expanded = Array.from(new Set(values(url, key)));
      if (raw.length === expanded.length && raw.every(function (value, i) { return value === expanded[i]; })) return;
      url.searchParams.delete(key);
      expanded.forEach(function (value) { url.searchParams.append(key, value); });
      url.searchParams.delete('page');
    });
  }

  function routeTemplate(current, options, previous) {
    var url = new URL(current);
    // Shopify's server expects repeated query keys for OR; a comma is a literal
    // value there even though the existing catalog adapters accept comma lists.
    normalizeNativeValues(url);
    if (options.templateRouting !== 'true') return url;
    var view = url.searchParams.get('view');
    var managed = Object.keys(typeViews).some(function (key) { return typeViews[key] === view; });
    if (view && !managed) return url;
    // JSON catalog templates support vendor/type and tag paths, not arbitrary
    // native filters or the virtual vendor/type searches. Never drop their scope.
    if (url.searchParams.has('q') || url.searchParams.has('kategoria') || url.searchParams.has('alennus') ||
        Array.from(url.searchParams.keys()).some(function (key) {
          return key.indexOf('filter.') === 0 && key !== 'filter.p.vendor' && key !== 'filter.p.product_type';
        })) return url;
    var target = typeView(url);
    var previousView = previous ? typeView(new URL(previous)) : target;
    if (previous && target !== previousView) {
      dimensionKeys.forEach(function (key) { url.searchParams.delete(key); });
    }
    if (target && target !== (options.baseTemplate || '')) url.searchParams.set('view', target);
    else url.searchParams.delete('view');
    if (view !== url.searchParams.get('view')) url.searchParams.delete('page');
    return url;
  }

  function mount(document, location) {
    document.querySelectorAll('[data-funky-filters]').forEach(function (form) {
      if (form.dataset.funkyMounted) return;
      form.dataset.funkyMounted = 'true';
      form.classList.add('funky-filters-ready');
      var current = new URL(location.href);
      var routed = routeTemplate(current, form.dataset);
      if (routed.href !== current.href) {
        // Old bookmarked/filter URLs get the same controls without adding a Back step.
        location.replace(routed.href);
        return;
      }
      function navigate(url) {
        location.assign(routeTemplate(url, form.dataset, location.href).href);
      }
      form.querySelectorAll('[data-funky-param]').forEach(function (select) {
        var selected = values(current, select.dataset.funkyParam);
        if (selected.length > 1) {
          var combined = document.createElement('option');
          combined.value = '__multiple__';
          combined.textContent = selected.join(', ');
          combined.selected = true;
          select.appendChild(combined);
        } else if (selected.length === 1) {
          if (!Array.prototype.some.call(select.options, function (option) { return option.value === selected[0]; })) {
            var missing = document.createElement('option');
            missing.value = selected[0];
            missing.textContent = selected[0];
            select.appendChild(missing);
          }
          select.value = selected[0];
        }
        select.addEventListener('change', function () {
          if (select.value !== '__multiple__') navigate(change(location.href, select.dataset.funkyParam, select.value));
        });
      });
      form.querySelectorAll('[data-funky-remove-key]').forEach(function (link) {
        link.addEventListener('click', function (event) {
          event.preventDefault();
          navigate(removeValue(location.href, link.dataset.funkyRemoveKey, link.dataset.funkyRemoveValue));
        });
      });
      form.querySelectorAll('[data-funky-tag-link]').forEach(function (link) {
        link.addEventListener('click', function (event) {
          event.preventDefault();
          navigate(changePath(location.href, link.href));
        });
      });
      var sale = form.querySelector('[data-funky-sale]');
      if (sale) sale.addEventListener('change', function () {
        navigate(changePath(location.href, sale.checked ? sale.dataset.urlOn : sale.dataset.urlOff));
      });
      var sort = form.querySelector('#SortBy');
      if (sort) sort.addEventListener('change', function (event) {
        // Read the current URL: the old theme caches query parameters before size clicks.
        // Capture also prevents the individual catalog sort adapters from navigating twice.
        event.stopImmediatePropagation();
        navigate(change(location.href, 'sort_by', sort.value));
      }, true);
      var reset = form.querySelector('[data-funky-clear]');
      function updateReset() {
        current = new URL(location.href);
        if (!reset) return;
        reset.href = clear(location.href, form.dataset.baseUrl).href;
        var hasQueryFilter = Array.from(current.searchParams.keys()).some(function (key) { return key.indexOf('filter.') === 0; });
        reset.hidden = !hasQueryFilter && form.dataset.hasTags !== 'true' &&
          !['fk_size', 'deck_group', 'group', 'mm_group', 'kategoria', 'alennus'].some(function (key) { return current.searchParams.has(key); });
      }
      updateReset();
      document.addEventListener('funky:filters-updated', updateReset);
      document.addEventListener('click', function () { setTimeout(updateReset, 0); });
      document.addEventListener('change', function () { setTimeout(updateReset, 0); });
      if (document.defaultView) document.defaultView.addEventListener('popstate', updateReset);
    });
  }

  return { routeTemplate: routeTemplate, values: values, change: change, removeValue: removeValue, changePath: changePath, clear: clear, mount: mount };
}));
